import ReminderInitializer from './ReminderInitializer';

export default ReminderInitializer;